import Vue from "vue";

//! Import Only Components of Vuetify You Needed
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VCard,
  VAvatar,
  VCarousel,
  VChip,
  VTextField,
  VProgressCircular,
  VSubheader,
  VDataTable,
  VCheckbox,
  VSelect,
  VTabs,
  VAlert,
  VBreadcrumbs,
  VParallax,
  VTextarea,
  VCombobox,
  VSwitch,
  VAutocomplete,
  VDialog,
  VDivider,
  VProgressLinear,
  VImg,
  VOverflowBtn,
  VBtnToggle,
  VPagination,
  VMenu,
  VResponsive,
  VRadioGroup,
  VExpansionPanel,
  VStepper,
  VDatePicker
} from "vuetify";

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VCard,
    VAvatar,
    VCarousel,
    VChip,
    VTextField,
    VProgressCircular,
    VSubheader,
    VDataTable,
    VCheckbox,
    VSelect,
    VTabs,
    VAlert,
    VBreadcrumbs,
    VParallax,
    VTextarea,
    VCombobox,
    VSwitch,
    VAutocomplete,
    VDialog,
    VDivider,
    VProgressLinear,
    VImg,
    VOverflowBtn,
    VBtnToggle,
    VPagination,
    VMenu,
    VResponsive,
    VRadioGroup,
    VExpansionPanel,
    VStepper,
    VDatePicker
  },
  theme: {
    //! Define Your Theme Here

    primary: "#FB0202",
    secondary: "#ffbe10",
    //accent: "#8b8b8b",
    //error: "#b71c1c",
    info: "#ffbe10",
    //success: "#a5d6a7",
    //warning: "#ffc107",

    options: {
      themeCache: {
        get: () => ''
      }
    }
  },
});



// WEBPACK FOOTER //
// ./resources/js/services/vuetify.js